/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Axis3d = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M4 4v16h16" }],
    ["path", { d: "m4 20 7-7" }]
  ]
];

export { Axis3d as default };
//# sourceMappingURL=axis-3d.js.map
